import React from "react";
import Close from "@mui/icons-material/Close";
import FilterAlt from "@mui/icons-material/FilterAlt";
import { CustomIconButton } from "../../../../code-connect/component/CustomIconButton";
import { CustomTextField } from "../../../../code-connect/component/CustomTextField";
import { MonthColumn } from "../../../../types/IFavoriteOrigins";

interface OriginManagerTableHeaderProps {
  hasSplitMonthColumns: boolean;
  isOriginFilterOpen: boolean;
  onOpenOriginFilter: () => void;
  onCloseOriginFilter: () => void;
  originFilterText: string;
  onOriginFilterTextChange: (value: string) => void;
  monthColumns: Array<MonthColumn & { colSpan?: number }>;
  monthGridTemplateColumns: string;
  getMonthLabel: (month: string) => string;
  registerMonthScroller: (key: string) => (node: HTMLDivElement | null) => void;
  onMonthScroll: (sourceKey: string, scrollLeft: number) => void;
}

const OriginManagerTableHeader: React.FC<OriginManagerTableHeaderProps> = ({
  hasSplitMonthColumns,
  isOriginFilterOpen,
  onOpenOriginFilter,
  onCloseOriginFilter,
  originFilterText,
  onOriginFilterTextChange,
  monthColumns,
  monthGridTemplateColumns,
  getMonthLabel,
  registerMonthScroller,
  onMonthScroll,
}) => {
  return (
    <div
      className={`dom-pane-row dom-pane-row--header${
        hasSplitMonthColumns ? " dom-table-header--split" : ""
      }`}
    >
      <div className="dom-pane-left dom-pane-left--header">
        <div className="dom-cell drag" />
        <div
          id="desktop-origin-header"
          className={`dom-cell origin${
            isOriginFilterOpen ? " dom-cell-origin--filter-open" : ""
          }`}
        >
          {isOriginFilterOpen ? (
            <CustomTextField
              id="dom-origin-filter-field"
              variant="outlined"
              state="focused"
              adornStart
              adornEnd
              startInstance={<FilterAlt sx={{ fontSize: 14, color: "#475569" }} />}
              endInstance={
                <Close
                  sx={{ fontSize: 14, color: "#475569", cursor: "pointer" }}
                  onClick={onCloseOriginFilter}
                />
              }
              placeholder="Filter Origins..."
              value={originFilterText}
              onChange={(e) => onOriginFilterTextChange(e.target.value)}
              autoFocus
              size="small"
              className="dom-origin-filter-field"
            />
          ) : (
            <>
              Origin
              <CustomIconButton
                color="secondary"
                size="small"
                state="enabled"
                className="dom-origin-filter-icon-btn"
                onClick={onOpenOriginFilter}
              >
                <FilterAlt fontSize="small" />
              </CustomIconButton>
            </>
          )}
        </div>
        <div className="dom-cell mode">Mode</div>
      </div>
      <div
        ref={registerMonthScroller("header")}
        className="dom-pane-center-scroll dom-pane-center-scroll--header"
        onScroll={(event) => onMonthScroll("header", event.currentTarget.scrollLeft)}
      >
        <div
          className="dom-pane-month-grid"
          style={{ gridTemplateColumns: monthGridTemplateColumns }}
        >
          {monthColumns.map((column) => (
            <div
              key={`${column.month}-${column.half}`}
              className={`dom-cell month${
                column.isSplit ? " dom-cell-month-split" : ""
              }`}
            >
              {!column.isSplit ? (
                <span className="dom-month-label">
                  {getMonthLabel(column.month)}
                </span>
              ) : (
                <div
                  className={`dom-split-month-header dom-split-month-header--${column.half}`}
                >
                  <span className="dom-split-month-label">
                    {column.half === "h1" ? getMonthLabel(column.month) : ""}
                  </span>
                  <div className="dom-split-half-label-wrap">
                    <span className="dom-split-half-label">
                      {column.half === "h1" ? "1H" : "2H"}
                    </span>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="dom-pane-right dom-pane-right--header">
        <div className="dom-cell actions">Actions</div>
      </div>
    </div>
  );
};

export default OriginManagerTableHeader;
